"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statusHexColors = exports.statusBgColors = exports.statusModifiers = exports.mimeTypes = exports.visualSettings = void 0;

var _colors = _interopRequireDefault(require("../colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var visualSettings = {
  title: {
    fontSizeValue: '18',
    fontColor: _colors.default.default
  },
  subtitle: {
    fontSizeValue: '14',
    fontColor: _colors.default.mediumGray
  }
};
exports.visualSettings = visualSettings;
var mimeTypes = {
  png: 'image/png',
  pdf: 'application/pdf',
  svg: 'image/svg+xml'
};
exports.mimeTypes = mimeTypes;
var statusModifiers = {
  Completed: '--status-completed',
  'On Track': '--status-on-track',
  'Some Disruption': '--status-minor-disruption',
  'Major Disruption': '--status-major-disruption',
  Discontinued: '--status-discontinued',
  discontinued: '--status-discontinued',
  Upcoming: '--status-upcoming',
  'Status Pending': '--status-pending'
};
exports.statusModifiers = statusModifiers;
var statusBgColors = {
  Completed: 'color-bg-completed',
  'On Track': 'color-bg-on-track',
  'Some Disruption': 'color-bg-minor-disruption',
  'Major Disruption': 'color-bg-major-disruption',
  Discontinued: 'color-bg-discontinued',
  discontinued: 'color-bg-discontinued',
  Upcoming: 'color-bg-upcoming',
  'Status Pending': 'color-bg-status-pending'
};
exports.statusBgColors = statusBgColors;
var statusHexColors = {
  Completed: _colors.default.completed,
  'On Track': _colors.default.onTrack,
  'Some Disruption': _colors.default.minorDisruption,
  'Major Disruption': _colors.default.majorDisruption,
  Discontinued: _colors.default.discontinued,
  discontinued: _colors.default.discontinued,
  Upcoming: _colors.default.upcoming,
  'Status Pending': _colors.default.statusPending
};
exports.statusHexColors = statusHexColors;